export enum RuntimeContext {
  CMS = 'Cms',
  ANGULAR_SHELL = 'AngularShell',
  SB_SHELL = 'SachbearbeiterShell',
  STANDALONE = 'Standalone'
}
